<template lang="html">
  <div :class="['drawer-menu', isActive ? 'active' : '']">
    <a href="#" :class="['logo', hasApps ? 'hamburger' : '']" @click="toggleActive">
      <img src="@/assets/logo.svg" alt="Engie Green" class="shape-darwin-logo">
    </a>
    <ul v-if="apps && apps.length>0" >
      <li class="close" @click="toggleActive"><button class="btn-icon"><i class="material-icons">close</i></button></li>
      <li :class="[menu.hasSubMenu() ? 'with-submenu' : '']" v-for="(menu, index) in apps" :key="index">
        <a :href="menu.href"><icon :name="menu.icon" v-if="menu.icon" /><span>{{ menu.label }}</span></a>
        <ul v-if="menu.hasSubMenu()">
          <li v-for="(sub, subIndex) in menu.subMenu" :key="index+subIndex">
            <a :href="sub.href"><icon :name="sub.icon" v-if="sub.icon" /><span>{{ sub.label }}</span></a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'DrawerMenu',
  data: () => ({
    isActive: false
  }),
  methods: {
    toggleActive: function () {
      this.isActive = !this.isActive
    }
  },
  computed: {
    ...mapGetters({ apps: 'apps' }),
    ...mapState({hasApps: state => { return state.apps && state.apps.rest && state.apps.rest.length > 0 }})
  }
}
</script>

<style lang="sass">
@import './static/sass/variables.sass'
@media screen and (max-width: 1023px)
  .drawer-menu
    display: none;
@media screen and (min-width: 1024px)
  .drawer-menu
    margin: 0
    padding: 0.4rem
    float: left

    &.active>ul
      display: flex
      opacity: 1
      left: 0

  a.logo
    display: inline-block

    &>.shape-darwin-logo
      margin-left: 1.5rem

    &.hamburger:before
      content: "\e5d2"
      font-family: $font-icon
      color: $white
      display: inline-block
      font-size: 2.2rem
      margin-left: 1.5rem
      float: left
      vertical-align: middle
      line-height: 70px

  .drawer-menu>ul
    display: block
    border-top-left-radius: 5px
    background-color: $blue-dark
    position: absolute
    left: -500px
    top: 0
    z-index: 3
    margin: 0
    min-width: 17rem
    color: $white
    font-size: 0.875rem
    text-transform: uppercase
    font-weight: bold
    justify-content: baseline
    align-items: flex-start
    flex-direction: column
    padding: 1.875rem 0 0
    opacity: 0
    transition-property: opacity, left
    transition-duration: 0.5s, 0.5s
    transition-delay: 0.2s

    .material-icons
      fill: rgba($white, 0.6)
      color: rgba($white, 0.6)
      margin-right: 1rem
      transition: color 0.2s, fill 0.2s

    svg.material-icons
      width: 18px
      padding-left: 3px
      padding-right: 3px
      height: 18px

    li
      padding: 0.75rem 4.125rem
      line-height: 1.5rem
      width: 100%
      box-sizing: border-box

      &:hover
        background-color: rgba($white, 0.2)
        .material-icons
          fill: $white
          color: $white

    .close
      button
        cursor: pointer
        text-align: center
        display: inline-block
        width: 100%
        margin: auto
        background-color: $blue
        border-radius: 50px
        padding: 0.4rem 0
      &:hover
        background-color: transparent
        button
          background-color: rgba($white, 0.2)
      .material-icons
        margin: 0
        font-size: 1.875rem
        color: $white

    .demo
      padding: 0
      margin-top: 2rem
      width: 100%
      text-align: center

      a
        display: block
        background-color: $blue-darker
        width: 100%
        padding: 1.875rem 0

    li.with-submenu
      position: relative

      &:after
        content: "\e315"
        font-family: $font-icon
        padding-left: 1.5rem
        font-size: 1.25rem
        position: relative
        top: 0.2rem

      &:hover ul
        display: block

      ul
        display: none
        position: absolute
        background-color: $blue-dark
        left: 100%
        top: 0
        padding: 0
        min-width: 18rem
        box-sizing: border-box
        opacity: 1
        text-align: left
        z-index: -1

        li
          width: 100%
          box-sizing: border-box
          margin: 0
          padding: 0

          a
            width: 100%
            display: inline-block
            padding: 0.9rem 0 0.9rem 1.8rem
            line-height: 1.5rem
            box-sizing: border-box

            svg.material-icons
              height: 18px
              width: 18px
              margin-left: 0
              padding-left: 0
              opacity: 0.5

          &:hover .material-icons
            opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/menu/DrawerMenu.vue